import type { FieldValues } from "react-hook-form";
import { FormComponent } from "../FormComponent";
import { FormNumber, type FormNumberProps } from "../fields/FormNumber";
import type { FormComponentProps } from "../types";

export type FormNumberComponentProps<TFieldValues extends FieldValues> =
	FormComponentProps<TFieldValues> & Omit<FormNumberProps<TFieldValues>, "control">;

export const FormNumberComponent = <TFieldValues extends FieldValues>(
	props: FormNumberComponentProps<TFieldValues>,
) => {
	const { formMethods, ...restProps } = props;
	const { control } = formMethods;
	return (
		<FormComponent {...props}>
			<FormNumber control={control} {...restProps} />
		</FormComponent>
	);
};
